<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab" @input="load">
          <b-tab v-for="item in gatewayOptions.slice(1)" :key="item.value" :title="item.text"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <client-select :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <form-select :model="filterFormModel" attribute="esignType" class="mr-1 mb-1" :options="[
                       {value: null, text: $t('selectEsignType')},
                       {value: 'token', text: $t('token')},
                       {value: 'hsm', text: $t('hsm')},
                   ]"></form-select>
            <form-select :model="filterFormModel" attribute="invoiceType" class="mr-1 mb-1" :options="[
                       {value: null, text: $t('selectInvoiceType')},
                       {value: 'valueAdded', text: $t('valueAdded')},
                       {value: 'sales', text: $t('sales')},
                       {value: 'publicProperty', text: $t('publicProperty')},
                       {value: 'nationalReserve', text: $t('nationalReserve')},
                       {value: 'other', text: $t('other')},
                       {value: 'likeInvoice', text: $t('likeInvoice')},
                   ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-md">{{ $t('client') }}</div>
            <div class="col-md">{{ $t('info') }}</div>
            <div class="col-md">{{ $t('time') }}</div>
            <div class="col-md"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-md">
              <span v-if="item.client">{{ item.client.companyName }} ({{ item.client.domain }})</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </div>
            <div class="col-md">
              <div>
                <b>{{ $t('invoiceType') }}: </b>
                <span v-if="item.invoiceType">{{ $t(item.invoiceType) }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('esignType') }}: </b>
                <span v-if="item.esignType">{{ $t(item.esignType) }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('esignHash') }}: </b>
                <span v-if="item.esignHash">{{ item.esignHash }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('apiUrl') }}: </b>
                <span v-if="item.apiUrl">{{ item.apiUrl }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('username') }}: </b>
                <span v-if="item.username">{{ item.username }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('password') }}: </b>
                <span v-if="item.password">{{ item.password }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('pattern') }}: </b>
                <span v-if="item.pattern">{{ item.pattern }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('serial') }}: </b>
                <span v-if="item.serial">{{ item.serial }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('comTaxCode') }}: </b>
                <span v-if="item.comTaxCode">{{ item.comTaxCode }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('comName') }}: </b>
                <span v-if="item.comName">{{ item.comName }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('comAddress') }}: </b>
                <span v-if="item.comAddress">{{ item.comAddress }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('comFax') }}: </b>
                <span v-if="item.comFax">{{ item.comFax }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-md">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('createdBy') }}: </b>
                <span v-if="item.createdBy">{{ item.createdBy.name }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('updateTime') }}: </b>
                <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('updatedBy') }}: </b>
                <span v-if="item.updatedBy">{{ item.updatedBy.name }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-md text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" size="xl" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-info">
        <div>{{ $t('alertInfo') }}: <span>
          <b>{{ clientApiUrl }}/webhook/hilo/{{formModel.client ? formModel.client : '[client_id]'}}</b>
        </span>
      </div>
        <div>{{ $t('method') }}: <span><b>POST</b></span></div>
      </div>
      <div class="row">
        <div class="col-6">
          <client-select :label="$t('client')" :model="formModel" attribute="client"
                         :errors="formErrors"></client-select>
          <form-select :full-width="true" :label="$t('supplier')" :model="formModel" attribute="gateway"
                       :options="gatewayOptions" :errors="formErrors"></form-select>
          <form-select :full-width="true" :label="$t('invoiceType')" :model="formModel" attribute="invoiceType"
                       :options="[
                       {value: null, text: $t('selectInvoiceType')},
                       {value: 'valueAdded', text: $t('valueAdded')},
                       {value: 'sales', text: $t('sales')},
                       {value: 'publicProperty', text: $t('publicProperty')},
                       {value: 'nationalReserve', text: $t('nationalReserve')},
                       {value: 'other', text: $t('other')},
                       {value: 'likeInvoice', text: $t('likeInvoice')},
                   ]" :errors="formErrors"></form-select>
          <form-select :full-width="true" :label="$t('esignType')" :model="formModel" attribute="esignType"
                       :options="[
                       {value: null, text: $t('selectEsignType')},
                       {value: 'token', text: $t('token')},
                       {value: 'hsm', text: $t('hsm')},
                   ]" :errors="formErrors"></form-select>
          <form-input v-if="formModel.esignType === 'token'" :label="$t('esignHash')" :model="formModel"
                      attribute="esignHash"
                      :errors="formErrors"></form-input>
          <div class="row align-items-center">
            <div class="col-9">
              <form-input :label="$t('webhookSecretKey')" :model="formModel" attribute="webhookSecretKey"
                          :errors="formErrors"></form-input>
            </div>
            <div class="col-3 text-right">
              <button @click="createNewKey(32)" class="btn btn-sm btn-primary mt-3">{{ $t('createNewKey') }}</button>
            </div>
          </div>
          <form-input :label="$t('apiUrl')" :model="formModel" attribute="apiUrl"
                      :errors="formErrors"></form-input>
        </div>
        <div class="col-6">
          <div class="row">
            <form-input class="col-6" :label="$t('username')" :model="formModel" attribute="username"
                        :errors="formErrors"></form-input>
            <form-input class="col-6" :label="$t('password')" :model="formModel" attribute="password"
                        :errors="formErrors"></form-input>
          </div>
          <div class="row">
            <form-input class="col-6" :label="$t('pattern')" :model="formModel" attribute="pattern"
                        :errors="formErrors"></form-input>
            <form-input class="col-6" :label="$t('serial')" :model="formModel" attribute="serial"
                        :errors="formErrors"></form-input>
          </div>
          <form-input :label="$t('comTaxCode')" :model="formModel" attribute="comTaxCode"
                      :errors="formErrors"></form-input>
          <form-input :label="$t('comName')" :model="formModel" attribute="comName" :errors="formErrors"></form-input>
          <form-input :label="$t('comAddress')" :model="formModel" attribute="comAddress"
                      :errors="formErrors"></form-input>
          <form-input :label="$t('comFax')" :model="formModel" attribute="comFax" :errors="formErrors"></form-input>
        </div>
      </div>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import ClientSelect from "@/components/ClientSelect.vue";
import crypto from "crypto";

export default {
  components: {ClientSelect, TimeRangePicker},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/invoice-setup',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        client: null,
        esignType: null,
        invoiceType: null,
      },
      defaultFormModel: {
        client: null,
        gateway: null,
        esignType: null,
        invoiceType: null,
        esignHash: null,
        webhookSecretKey: null,
        username: null,
        password: null,
        pattern: null,
        serial: null,
        comTaxCode: null,
        comName: null,
        comAddress: null,
        comFax: null,
        apiUrl: null
      },
      gatewayOptions: [],
      tab: 0,
      clientApiUrl: process.env.NODE_ENV === 'development' ? 'https://clientapidev.phonenet.io' : 'https://clientapi.phonenet.io',
    }
  },
  i18n: {
    messages: {
      en: {
        supplier: 'Supplier',
        chooseSupplier: 'Choose a supplier',
        esignType: 'Type of digital signature',
        selectEsignType: 'Select digital signature type',
        invoiceType: 'Type of invoice used',
        selectInvoiceType: 'Select invoice type',
        esignHash: 'Hash code',
        pattern: 'Invoice number',
        serial: 'Invoice symbol',
        token: 'Token',
        hsm: 'HSM',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        valueAdded: 'VAT invoice',
        publicProperty: 'Invoice for sale of public property',
        nationalReserve: 'National reserve sales invoice',
        other: 'Other types of invoices',
        sales: 'Sales invoice',
        likeInvoice: 'Documents printed, issued, used and managed like invoices',
        comTaxCode: 'Tax code of the issuing unit',
        comName: 'Name of the issuing unit',
        comAddress: 'Address of the issuing unit',
        comFax: 'Fax of the issuing unit',
        webhookSecretKey: 'Webhook secret key',
        createNewKey: 'Create new key',
        alertInfo: 'Set up webhook to confirm invoices in series',
        method: 'Method',
        apiUrl: 'API URL',
      },
      vi: {
        supplier: 'Nhà cung cấp',
        chooseSupplier: 'Chọn nhà cung cấp',
        esignType: 'Loại chữ ký số',
        selectEsignType: 'Chọn loại chữ ký số',
        invoiceType: 'Loại hoá đơn sử dụng',
        selectInvoiceType: 'Chọn loại hoá đơn',
        esignHash: 'Mã hash',
        pattern: 'Mẫu số của hóa đơn',
        serial: 'Ký hiệu của hóa đơn',
        token: 'Token',
        hsm: 'HSM',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        valueAdded: 'Hoá đơn GTGT',
        publicProperty: 'Hoá đơn bán tài sản công',
        nationalReserve: 'Hoá đơn bán hàng dự trữ quốc gia',
        other: 'Các loại hoá đơn khác',
        sales: 'Hoá đơn bán hàng',
        likeInvoice: 'Các chứng từ được in, phát hành, sử dụng và quản lý như hoá đơn',
        comTaxCode: 'MST đơn vị phát hành',
        comName: 'Tên đơn vị phát hành',
        comAddress: 'Địa chỉ đơn vị phát hành',
        comFax: 'Fax của đơn vị phát hành',
        webhookSecretKey: 'Mã bảo mật webhook',
        createNewKey: 'Tạo mã mới',
        alertInfo: 'Cài đặt webhook để xác nhận hoá đơn theo chuỗi',
        method: 'Phương thức',
        apiUrl: 'API URL',
      }
    }
  },
  methods: {
    search() {
      this.filterFormModel.page = 1;
      this.load()
    },
    load: function () {
      this.filterFormModel.gateway = this.getGatewayId(this.tab);
      let loader = this.$loading.show();
      this.loading = true;
      this.listLoading = true;
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
        this.listLoading = false;
        if (this.afterLoad) {
          this.afterLoad();
        }
      });
    },
    getGatewayId: function (index) {
      let country = this.gatewayOptions.length ? this.gatewayOptions.slice(1)[index] : null;
      return country ? country.value : null;
    },
    create: function () {
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      this.formModel.gateway = this.filterFormModel.gateway;
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    },
    createNewKey(bytesLength) {
      const buf = crypto.randomBytes(Number(bytesLength));
      this.formModel.webhookSecretKey = buf.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }
  },
  mounted() {
    this.gatewayOptions = [{value: null, text: this.$t('chooseSupplier')}]
    this.$service.get('/invoice-gateway', {
      params: {
        page: 1,
        pageSize: 100
      }
    }).then(response => {
      if (response && response.data) {
        response.data.docs.forEach(gateway => {
          this.gatewayOptions.push({value: gateway._id, text: `${gateway.name} (${gateway.code})`});
        })
      }
    })
  }
};
</script>